import ClassNames from "classnames";
import { FunctionComponent, useEffect, useRef } from "react";
import styles from "../stylesheets/components/left-overlay-submenu.module.css";
import mainMenuStyles from "../stylesheets/components/main-menu.module.css";
import { Language, MainMenuItem, PageState } from "../types/index.js";
import { useKeyDown } from "../utils/hooks.js";
import Icon from "./Icon.js";
import MainMenuLevelLeftNav from "./MainMenuLevelLeftNav.js";

interface Props {
  isPreview: boolean;
  languageId: Language;
  pages: PageState;
  currentMenuItem: MainMenuItem;
  activePagePath: string[];
  fallbackLanguageId: Language | undefined;
  onClose: () => void;
}

const LeftOverlaySubmenu: FunctionComponent<Props> = ({
  isPreview,
  languageId,
  currentMenuItem,
  pages,
  activePagePath,
  fallbackLanguageId,
  onClose,
}) => {
  const submenuRef = useRef<HTMLDivElement>(null);
  useKeyDown("Escape", onClose);

  useEffect(() => {
    const onClick = ({ target }: MouseEvent) => {
      if (!(target instanceof Element)) return;

      const clickedOutside = !submenuRef.current?.contains(target);
      clickedOutside && onClose();
    };
    document.addEventListener("click", onClick, { passive: true });

    return () => {
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div
      ref={submenuRef}
      className={ClassNames(
        styles.LeftOverlayNav__Submenu,
        mainMenuStyles.MainMenu__LeftOverlayNav__Submenu,
      )}
    >
      <button
        className={ClassNames("Btn--bare", styles.LeftOverlayNav__BackBtn)}
        type="button"
        onClick={onClose}
      >
        <Icon glyph="arrow-left" />
      </button>

      <ul
        className={ClassNames(
          mainMenuStyles.MainMenu__List,
          mainMenuStyles["MainMenu__List--level0"],
        )}
      >
        <MainMenuLevelLeftNav
          currentMenuItem={currentMenuItem}
          isPreview={isPreview}
          languageId={languageId}
          parentId={currentMenuItem.id}
          pages={pages}
          menuLevel={0}
          activePagePath={activePagePath}
          fallbackLanguageId={fallbackLanguageId}
          onMenuItemClick={onClose}
        />
      </ul>
    </div>
  );
};

export default LeftOverlaySubmenu;
